import { css } from 'styled-components';
import { CFMixins } from '../../mixins';
import { CFTokens } from '../../tokens';
/* eslint-disable sort-keys */
export const CFBaseTextTokens = {
    SPACE_BETWEEN: {
        Title1: CFTokens.SPACER.D,
        Title2: CFTokens.SPACER.D,
        Title3: CFTokens.SPACER.D,
        Title4: CFTokens.SPACER.D,
        Title5: CFTokens.SPACER.D,
        Title6: CFTokens.SPACER.D,
        Subtitle1: CFTokens.SPACER.D,
        Subtitle2: CFTokens.SPACER.D,
        Subtitle3: CFTokens.SPACER.D,
        BodyCallout: CFTokens.SPACER.D,
        BodyLarge: CFTokens.SPACER.D,
        BodyLargeSemibold: CFTokens.SPACER.D,
        BodyLargeBold: CFTokens.SPACER.D,
        Body: CFTokens.SPACER.C,
        BodySemibold: CFTokens.SPACER.C,
        BodyBold: CFTokens.SPACER.C,
        Body2: CFTokens.SPACER.B,
        Body2Semibold: CFTokens.SPACER.B,
        Body2Bold: CFTokens.SPACER.B,
        Micro: CFTokens.SPACER.B,
        MicroSemibold: CFTokens.SPACER.B,
        MicroBold: CFTokens.SPACER.B,
    },
};
/* eslint-disable sort-keys */
export const CFBaseTextStyleHelpers = {
    align: ({ align = 'left' }) => align,
    color: ({ color = 'text-and-element-default' }) => CFTokens.getCFColorValue(color),
    rootWrapperSpacing: ({ spec }) => {
        return css `
      gap: ${CFBaseTextTokens.SPACE_BETWEEN[spec]}px;
    `;
    },
    spacer: ({ spacer }) => spacer ? CFMixins.spacer({ spacer }) : null,
    typeSpecNative: ({ scale, spec }) => {
        if (scale) {
            return CFMixins.typeSpec(CFTokens.getCFTypeSpecScale(scale));
        }
        if (spec) {
            return CFMixins.typeSpec(CFTokens.getCFTypeSpec(spec));
        }
        return CFMixins.typeSpec(CFTokens.TYPE_SPEC.BODY);
    },
    typeSpecWeb: ({ scale, spec }) => {
        if (scale) {
            return CFMixins.typeSpec(CFTokens.getCFTypeSpecScale(scale));
        }
        if (spec) {
            return CFMixins.typeSpec(CFTokens.getCFTypeSpec(spec), true);
        }
        return CFMixins.typeSpec(CFTokens.TYPE_SPEC.BODY, true);
    },
};
export const CFBaseTextStyles = {
    Root: css `
    color: ${CFBaseTextStyleHelpers.color};
    text-align: ${CFBaseTextStyleHelpers.align};
    ${CFBaseTextStyleHelpers.spacer}
  `,
    RootNative: css `
    ${CFBaseTextStyleHelpers.typeSpecNative}
  `,
    RootWeb: css `
    ${CFBaseTextStyleHelpers.typeSpecWeb}
  `,
    RootWrapper: css `
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    ${CFBaseTextStyleHelpers.rootWrapperSpacing};
    ${CFBaseTextStyleHelpers.spacer};
  `,
};
